export default {
    mounted() {
        setTimeout(() => {
            let rect = document.getElementById('indication').getBoundingClientRect();
            this.$store.dispatch('getIndicationPos', rect.top)
        }, 1000)
    }
}